import { dismissSticky, error } from 'client-portal/utils/banners';
import { service } from '@ember/service';
import { task, timeout, waitForProperty } from 'ember-concurrency';
import Component from '@glimmer/component';
import ENV from 'client-portal/config/environment';

export default class SharedCardError extends Component {
  @service intl;

  timeToError = ENV.stripeElementLoadingErrorDelay;

  constructor() {
    super(...arguments);
    this.handleError.perform();
  }

  handleError = task(async () => {
    let { card } = this.args;
    let didShow = false;

    try {
      await timeout(this.timeToError);
      if (!card.areElementsReady) {
        didShow = true;
        this.showErrorBanner();
      }
      await waitForProperty(card, 'areElementsReady');
    } finally {
      if (didShow) dismissSticky();
    }
  });

  showErrorBanner() {
    let content = document.createElement('p');
    content.innerText =
      'There was an error loading this page. Please check your internet connection, refresh your browser, and try again.';
    error({
      title: this.intl.t('messages.error.resourcesLoadFailed'),
      content,
    });
  }
}
